var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-container flex"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"tab-item text-center",on:{"click":function($event){return _vm.onTabClick(item)}}},[_c('img',{attrs:{"src":_vm.imgView(item.icon),"alt":"icon"}}),_c('div',{staticClass:"tab-item-name"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }